import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=3a6ef2f4&scoped=true&"
import script from "./Warehouse.vue?vue&type=script&lang=js&"
export * from "./Warehouse.vue?vue&type=script&lang=js&"
import style0 from "./Warehouse.vue?vue&type=style&index=0&id=3a6ef2f4&prod&lang=css&"
import style1 from "./Warehouse.vue?vue&type=style&index=1&id=3a6ef2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6ef2f4",
  null
  
)

export default component.exports